var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "dialog-base",
    {
      attrs: {
        visible: _vm.visible,
        title: _vm.dialogTitle,
        size: "md",
        "cancel-text": "Huỷ",
        "confirm-text": "Lưu lại",
        "confirm-loading": _vm.isSaving,
        "use-panel": false,
        top: "6vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        confirm: _vm.handleSave,
        cancel: _vm.handleClose,
      },
    },
    [
      _c("div", { staticClass: "sk-panel mb-4" }, [
        _c("div", { staticClass: "sk-panel-head" }, [
          _c("div", { staticClass: "sk-panel-icon sk-panel-icon--success" }, [
            _c("i", { staticClass: "el-icon-office-building" }),
          ]),
          _c("div", [
            _c("p", { staticClass: "sk-panel-title" }, [
              _vm._v(_vm._s(_vm.targetName || "Đang tải...")),
            ]),
            _c("p", { staticClass: "sk-panel-subtitle" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.targetTypeLabel) +
                  " — Chọn các khoản thu muốn thêm\n        "
              ),
            ]),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "sk-note sk-note--warning mb-3" }, [
        _c("i", { staticClass: "el-icon-warning-outline" }),
        _c("span", [
          _vm._v("\n      Thao tác lưu sẽ "),
          _c("strong", [_vm._v("đồng bộ toàn bộ")]),
          _vm._v(" danh sách khoản thu đã chọn."),
          _c("br"),
          _vm._v("\n      Khoản thu bị bỏ tích sẽ bị "),
          _c("strong", [_vm._v("xóa hẳn")]),
          _vm._v(
            " khỏi lớp/nhóm/gói này và đồng thời cũng bị xoá hẳn khỏi danh sách đăng ký của học sinh trong lớp/nhóm/gói.\n    "
          ),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "flex items-center gap-3 mb-3" },
        [
          _c("el-input", {
            staticStyle: { "max-width": "320px" },
            attrs: {
              placeholder: "Tìm kiếm tên khoản thu...",
              "prefix-icon": "el-icon-search",
              clearable: "",
            },
            on: { input: _vm.filterRevenues },
            model: {
              value: _vm.keyword,
              callback: function ($$v) {
                _vm.keyword = $$v
              },
              expression: "keyword",
            },
          }),
          _c("span", { staticClass: "rsd-count-label" }, [
            _vm._v("\n      Đã chọn:\n      "),
            _c("strong", { staticClass: "rsd-count-selected" }, [
              _vm._v(_vm._s(_vm.selectedIds.length)),
            ]),
            _vm._v("\n      / " + _vm._s(_vm.revenueList.length) + "\n    "),
          ]),
        ],
        1
      ),
      _vm.isLoading
        ? _c("div", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: true,
                expression: "true",
              },
            ],
            staticClass: "rsd-loading-area",
          })
        : _c(
            "div",
            { staticClass: "rsd-checkbox-list" },
            [
              _vm._l(_vm.filteredList, function (item) {
                return _c(
                  "div",
                  {
                    key: item.totalRevenueId,
                    staticClass: "rsd-checkbox-item",
                    class: {
                      "rsd-checkbox-item--checked": _vm.isChecked(
                        item.totalRevenueId
                      ),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.toggleItem(item.totalRevenueId)
                      },
                    },
                  },
                  [
                    _c("el-checkbox", {
                      staticClass: "rsd-checkbox",
                      attrs: { value: _vm.isChecked(item.totalRevenueId) },
                      on: {
                        change: function ($event) {
                          return _vm.toggleItem(item.totalRevenueId)
                        },
                      },
                      nativeOn: {
                        click: function ($event) {
                          $event.stopPropagation()
                        },
                      },
                    }),
                    item.code
                      ? _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: `Mã khoản: ${item.code}`,
                              placement: "top",
                            },
                          },
                          [
                            _c("span", { staticClass: "rsd-checkbox-label" }, [
                              _vm._v(_vm._s(item.totalRevenueName)),
                            ]),
                          ]
                        )
                      : _c("span", { staticClass: "rsd-checkbox-label" }, [
                          _vm._v(_vm._s(item.totalRevenueName)),
                        ]),
                  ],
                  1
                )
              }),
              _vm.filteredList.length === 0
                ? _c("div", { staticClass: "rsd-empty" }, [
                    _c("i", {
                      staticClass: "el-icon-document-remove rsd-empty-icon",
                    }),
                    _vm.keyword
                      ? _c("p", [_vm._v("Không tìm thấy khoản thu phù hợp.")])
                      : _c("p", [_vm._v("Trường chưa có khoản thu nào.")]),
                  ])
                : _vm._e(),
            ],
            2
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }